import { parseAutoImageId } from '@dispositio/core';
import { useSyncExternalStore } from 'react';
import { renderAvatar } from './autoAvatars';

/** Bilder als Data-URI zwischenspeichern: SVG-Karten dürfen keine externen Bilder laden, Data-URIs schon. Automatische Bilder entstehen hier. */
const cache = new Map<string, string>();
const pending = new Set<string>();
const failed = new Set<string>();
const listeners = new Set<() => void>();
let version = 0;

const notify = (): void => {
  version++;
  for (const l of listeners) l();
};

export const getAssetData = (id: string): string | null => cache.get(id) ?? null;

export function loadAsset(id: string): void {
  if (cache.has(id) || pending.has(id) || failed.has(id)) return;
  pending.add(id);
  void (async () => {
    try {
      const auto = parseAutoImageId(id);
      if (auto) {
        cache.set(id, renderAvatar(auto));
        return;
      }
      const res = await fetch(`/api/assets/${id}`, { credentials: 'same-origin' });
      if (!res.ok) throw new Error(String(res.status));
      const blob = await res.blob();
      const data = await new Promise<string>((resolve, reject) => {
        const r = new FileReader();
        r.onload = () => resolve(String(r.result));
        r.onerror = () => reject(r.error);
        r.readAsDataURL(blob);
      });
      cache.set(id, data);
    } catch {
      failed.add(id);
    } finally {
      pending.delete(id);
      notify();
    }
  })();
}

/** Zähler, der sich ändert, sobald ein Bild geladen wurde (löst das Neuzeichnen der Karten aus). */
export function useAssetVersion(): number {
  return useSyncExternalStore(
    (cb) => {
      listeners.add(cb);
      return () => listeners.delete(cb);
    },
    () => version,
  );
}
